// What a held-back record is and what its columns are called, in the words the
// screens use — so the held-back list (#693) and the area's own choice (#394)
// can say what differs. A column not listed is "Other details" (conflict-diff.ts).
import type { DeviceTable } from './device-store';

/** Each table as the measurer knows it. */
export const TABLE_NAMES: Record<DeviceTable, string> = {
  measure: 'Measure',
  building: 'Building',
  area: 'Area',
  areatag: 'Site requirement',
  version: 'Version',
  option: 'Option',
  jobprice: 'Job price',
  reviewanswer: 'REVIEW answer',
  photo: 'Photo',
  visit: 'Condition visit',
  visitarea: 'Condition area',
  observation: 'Condition rating',
  evidencephoto: 'Condition photo',
  visitareatag: 'Condition tick',
  defect: 'Defect',
};

const NAME = { hig_name: 'Name' };
const NOTES = { hig_notes: 'Notes' };
const ORDER = { hig_sortorder: 'Order in the list' };

/** Columns as the screens name them, per table. Two columns under one name are one part (an area's surfaces and their hours). */
export const FIELD_LABELS: Partial<Record<DeviceTable, Record<string, string>>> = {
  area: {
    ...NAME,
    hig_side: 'Internal / External',
    hig_scopenotes: 'Scope notes',
    hig_accessneeds: 'Access needs',
    hig_exclusions: 'Exclusions',
    hig_defectsnote: 'Defects note',
    ...ORDER,
    hig_surfaces: 'Surfaces',
    hig_measuredhours: 'Surfaces',
    hig_downtimepercent: 'Down time',
    hig_abseilpercent: 'Abseil',
    hig_approvedhours: 'Approved hours',
    hig_approvedhourssource: 'Approved hours',
    hig_sitereqs: 'Site requirements',
    hig_assessedhours: 'PM assessment',
    hig_assessnotes: 'PM assessment',
  },
  building: { ...NAME, hig_count: 'How many', ...ORDER, ...NOTES },
  measure: { ...NAME, hig_status: 'Status', hig_labourtype: 'Labour', hig_measuredon: 'Measured on', hig_assessedon: 'Assessed on', ...NOTES },
  version: { ...NAME, hig_pricingdate: 'Pricing date', hig_recommendedoptionid: 'Recommended option', ...NOTES },
  option: {
    ...NAME,
    hig_kind: 'Kind',
    hig_labourtype: 'Labour',
    hig_termyears: 'Term (years)',
    hig_maintenancetier: 'Tier',
    hig_recommended: 'Recommended',
    hig_scope: 'Pricing lines',
    hig_markupmaterials: 'Markup on materials %',
    hig_markupother: 'Markup on other %',
    hig_negotiatingfactor: 'Negotiating factor',
    hig_totalsell: 'Total sell',
    hig_totalcost: 'Total cost',
    hig_gppercent: 'GP %',
    hig_totalhours: 'Total hours',
    hig_totallitres: 'Total litres',
    ...ORDER,
  },
  jobprice: { ...NAME, hig_costperlitre: 'Cost per litre', hig_dayrate: 'Day rate', hig_transport: 'Transport', hig_diesel: 'Diesel', hig_rate: 'Rate' },
  reviewanswer: { hig_answer: 'Answer', hig_comment: 'Comment' },
  visit: { hig_visittype: 'Visit type', hig_ratingscale: 'Rating scale', hig_inspectedon: 'Inspected on', hig_siteplan: 'Site plan', ...NOTES },
  visitarea: { ...NAME, hig_conditiontags: 'Condition ticks', hig_priority: 'Priority', hig_deliverymode: 'Delivery', hig_outlookyear: 'Outlook year', hig_accesslines: 'Access', ...ORDER },
  observation: { ...NAME, hig_rating: 'Rating', hig_extent: 'Extent', hig_defects: 'Defects', hig_note: 'Note', hig_noteedited: 'Note', ...ORDER },
  defect: {
    hig_name: 'Defect',
    hig_details: 'Details',
    hig_cause: 'Cause',
    hig_chargeroute: 'Charge',
    hig_status: 'Status',
    hig_assignedto: 'Assigned to',
    hig_dueon: 'Due',
    hig_clientverifiername: 'Verified by (client)',
  },
};
